/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ActorActivityRecordActorUserId } from './ActorActivityRecordActorUserId';
import {
    ActorActivityRecordActorUserIdFromJSON,
    ActorActivityRecordActorUserIdFromJSONTyped,
    ActorActivityRecordActorUserIdToJSON,
    ActorActivityRecordActorUserIdToJSONTyped,
} from './ActorActivityRecordActorUserId';
import type { CreateTimeEntryRequestAppointmentId } from './CreateTimeEntryRequestAppointmentId';
import {
    CreateTimeEntryRequestAppointmentIdFromJSON,
    CreateTimeEntryRequestAppointmentIdFromJSONTyped,
    CreateTimeEntryRequestAppointmentIdToJSON,
    CreateTimeEntryRequestAppointmentIdToJSONTyped,
} from './CreateTimeEntryRequestAppointmentId';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface ValidateSurchargeRequest
 */
export interface ValidateSurchargeRequest {
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof ValidateSurchargeRequest
     */
    userId: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof ValidateSurchargeRequest
     */
    studentId: ActorActivityRecordActorUserId | null;
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof ValidateSurchargeRequest
     */
    classId: ActorActivityRecordActorUserId | null;
    /**
     * 
     * @type {CreateTimeEntryRequestAppointmentId}
     * @memberof ValidateSurchargeRequest
     */
    appointmentBookingId: CreateTimeEntryRequestAppointmentId | null;
}

/**
 * Check if a given object implements the ValidateSurchargeRequest interface.
 */
export function instanceOfValidateSurchargeRequest(value: object): value is ValidateSurchargeRequest {
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('studentId' in value) || value['studentId'] === undefined) return false;
    if (!('classId' in value) || value['classId'] === undefined) return false;
    if (!('appointmentBookingId' in value) || value['appointmentBookingId'] === undefined) return false;
    return true;
}

export function ValidateSurchargeRequestFromJSON(json: any): ValidateSurchargeRequest {
    return ValidateSurchargeRequestFromJSONTyped(json, false);
}

export function ValidateSurchargeRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ValidateSurchargeRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': ApiUserTasksGetPageParameterFromJSON(json['userId']),
        'studentId': ActorActivityRecordActorUserIdFromJSON(json['studentId']),
        'classId': ActorActivityRecordActorUserIdFromJSON(json['classId']),
        'appointmentBookingId': CreateTimeEntryRequestAppointmentIdFromJSON(json['appointmentBookingId']),
    };
}

export function ValidateSurchargeRequestToJSON(json: any): ValidateSurchargeRequest {
    return ValidateSurchargeRequestToJSONTyped(json, false);
}

export function ValidateSurchargeRequestToJSONTyped(value?: ValidateSurchargeRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': ApiUserTasksGetPageParameterToJSON(value['userId']),
        'studentId': ActorActivityRecordActorUserIdToJSON(value['studentId']),
        'classId': ActorActivityRecordActorUserIdToJSON(value['classId']),
        'appointmentBookingId': CreateTimeEntryRequestAppointmentIdToJSON(value['appointmentBookingId']),
    };
}

